<!--  -->
<template>
  <div class="applet_box">
    <div class="search_box">
      <el-button type="success" icon="el-icon-plus" style="margin-bottom:10px" @click="band">新增绑定</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="80"
        align="center"
      />
      <el-table-column
        prop="config_id"
        label="配置id"
        width="80"
        align="center"
      />
      <el-table-column
        prop="title"
        label="配置标题"
        width="180"
        align="center"
      />
      <el-table-column
        prop="accounts_name"
        label="小程序名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="管理员名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="状态"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
          <i v-if="scope.row.status == 2" class="el-icon-error stopew" />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="un_bind_time_text"
        label="解绑时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="bind_time_text"
        label="绑定时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="appid"
        align="center"
      />

      <el-table-column
        prop="address"
        label="是否关闭广告"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="mini">解绑</el-button> -->
          <el-switch
            v-model="scope.row.ad_switch"
            active-text="开"
            inactive-text="关"
            :active-value="1"
            :inactive-value="2"
            @change="changewr($event,scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      title="绑定"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="30%"
    >
      <appletdialog ref="bandwechatwe" @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import appletdialog from './components/appletdialog.vue'
import { nineconfigurelist, updateninesquaresConfigBind } from '@/api/sourceMaterial.js'
export default {
  components: {
    PaginationRight,
    appletdialog
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        page_size: 10
      },
      dialogVisible: false

    }
  },
  created() {
    this.wecharselist()
  },
  mounted() {

  },
  methods: {
    async wecharselist() {
      const data = await nineconfigurelist(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.wecharselist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.wecharselist()
    },
    band() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.bandwechatwe.send()
      })
    },
    close() {
      this.dialogVisible = false
      this.wecharselist()
    },
    async changewr(val, item) {
      console.log(val, item)
      await updateninesquaresConfigBind({
        adSwitch: val,
        id: item.id
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.wecharselist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.applet_box{
  padding: 20px;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.search_box{
  text-align: right;
}
</style>
